import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import LogoImg from "../Image/Logo.png";

function UserRegister() {
  const [displayText, setDisplayText] = useState("");
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });

  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [showForm, setShowForm] = useState(true);
  const [showPopup, setShowPopup] = useState(false); // Single state for popup visibility
  const [loading, setLoading] = useState(false);

  const nameRegex = /^[a-zA-Z \-_]+$/;
  const nameRegex1 = /^[a-zA-Z][a-zA-Z \-_]*$/;

  const handleSubmit = async (event) => {
    event.preventDefault();

    let hasErrors = false;
    let errorMessage = "";

    if (!nameRegex1.test(form.firstName) && !nameRegex.test(form.lastName)) {
      errorMessage = "Please enter valid first and last name.";
      hasErrors = true;
    } else if (!nameRegex1.test(form.firstName)) {
      errorMessage =
        "First name must start with a letter and can contain letters, spaces, hyphens, underscores, or apostrophes.";
      hasErrors = true;
    } else if (!nameRegex.test(form.lastName)) {
      errorMessage =
        "Last name can only contain letters, spaces, hyphens, underscores, or apostrophes.";
      hasErrors = true;
    }

    setError(errorMessage.trim());

    if (hasErrors) {
      return;
    }

    setShowForm(false);
    setShowPopup(false); // Close any existing popup
    setLoading(true); // Show loader

    const data = {
      first_name: form.firstName,
      last_name: form.lastName,
      email_id: form.email,
      platform_type: "web",
    };

    const auth = window.catalyst.auth;
    const signupResponse = await auth.signUp(data);

    setLoading(false); // Hide loader after API call
    if (signupResponse.status === 200) {
      setDisplayText(
        "An account verification email has been sent to your email address"
      );
      setShowPopup(true); // Show success popup
      setTimeout(() => {
        navigate("/");
      }, 3000);
    } else {
      setDisplayText(signupResponse.message);
      setShowPopup(true); // Show error popup
    }
  };

  return (
    <div className="login_wall" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/Login_Background.jpg)` }}>
      <div className="Div_logo">
        <img
          src={LogoImg}
          alt="Logo"
        />
      </div>
      <div className="Fixed_button">
        <a href="#">Contact us</a>
      </div>

      {!showPopup && !loading && ( // Display form only if no popup or loader is visible
        <div className="Login_Box Signup_Box">
          <h2 className="Signup_heading">Signup</h2>

          {showForm && (
            <form onSubmit={handleSubmit}>
              <label htmlFor="firstName">
                <input
                  name="firstName"
                  className="inputs"
                  placeholder="First Name"
                  value={form.firstName}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      firstName: e.target.value,
                    })
                  }
                  required
                />
              </label>
              <label htmlFor="lastName">
                <input
                  className="inputs"
                  placeholder="Last Name"
                  value={form.lastName}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      lastName: e.target.value,
                    })
                  }
                  required
                />
              </label>
              <label htmlFor="email">
                <input
                  className="inputs"
                  type="email"
                  placeholder="Email address"
                  value={form.email}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      email: e.target.value,
                    })
                  }
                  required
                />
              </label>
              <input type="submit" value="Signup" />
            </form>
          )}

          {error && <p className="error-message">{error}</p>}

          <div className="or-divider"></div>

          <div className="sign-in-link">
            <p>
              Already have an account?{" "}
              <Link
                to="/"
                style={{
                  color: "black",
                  textDecoration: "underline",
                  backgroundColor: "rgb(243, 207, 5)",
                  fontSize: "24px",
                  padding: "5px",
                  fontWeight: "lighter",
                }}
              >
                Sign In 
              </Link>
            </p>
          </div>

        </div>
      )}

      {loading && <div className="loader"></div>}
      {showPopup && (
        <div className="popups">
          <div className="popup-content">
            <p className="popups-p">{displayText}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserRegister;
